import React from 'react';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import { alertItem } from '../types';

type Props = {
  item?: alertItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function AlertViewModal({ item, open, onClose }: Props) {
  const handleNavigate = () => {
    if (item && item.url) {
      window.open(item.url);
    }
    onClose();
  };

  return (
    <ModalDialog
      open={open}
      title="Navigate to myServices"
      text="Are you sure you want to open myServices page?"
      onClose={onClose}
      onConfirm={handleNavigate}
      cancelBtnText="Cancel"
      confirmBtnText="OK"
    />
  );
}

export default AlertViewModal;
